/* eslint-disable */
/* Generated by scripts/generate-share-voice-sidebar-categories.ts - do not edit */

/**
 * Runtime array of ShareVoiceSidebarCategory enum values from schema.graphql.
 * Used for Zod schemas (e.g. URL search params) and iteration.
 * Shared across discovery, news feed, and share of voice.
 */
export const SIDEBAR_FILTER_CATEGORIES = [
  "AUTHOR",
  "CATEGORY",
  "COUNTRY",
  "DOMAIN_AUTHORITY_BUCKETS",
  "EVENT",
  "FEED_ARTICLE_TAG",
  "INITIATIVE",
  "KEY_MESSAGE",
  "LANGUAGE",
  "NARRATIVE_CLUSTER",
  "PEOPLE",
  "PROMINENCE",
  "PUBLISHER",
  "PUBLISHER_MEDIA_LIST_GROUP_ID",
  "PUBLISHER_MEDIA_LIST_ID",
  "READERSHIP_BUCKETS",
  "REGION",
  "SCORE_BUCKETS",
  "SENTIMENT",
  "SOCIAL_BUCKETS",
  "THEME",
  "TIER",
  "TOPIC",
] as const;

const DYNAMIC_SIDEBAR_FILTER_CATEGORIES = [
  "AUTHOR",
  "EVENT",
  "FEED_ARTICLE_TAG",
  "INITIATIVE",
  "NARRATIVE_CLUSTER",
  "PEOPLE",
  "PUBLISHER",
  "PUBLISHER_MEDIA_LIST_GROUP_ID",
  "PUBLISHER_MEDIA_LIST_ID",
  "THEME",
  "TOPIC",
] as const;

const dynamicCategorySet = new Set<string>(DYNAMIC_SIDEBAR_FILTER_CATEGORIES);

/** Whether `category` is a dynamic sidebar filter (fixed list, not store-derived). */
export const isDynamicSidebarCategory = (category: string): boolean =>
  dynamicCategorySet.has(category);
